import { iconDefaults, type IconProps } from './Icon'

export function AlertIcon(props: IconProps) {
  return (
    <svg {...iconDefaults} {...props}>
    <path d="M12 4.5 2.8 20h18.4L12 4.5Z" />
    <path d="M12 10v4.2M12 17.2v.2" />
    </svg>
  )
}
